<template>
  <q-tabs
    v-model="tab"
    active-color="primary"
    indicator-color="transparent"
    align="justify"
    dense
    narrow-indicator
    class="text-dark q-py-xs"
  >
    <q-tab
      v-for="item in cardItems"
      :key="item.name"
      :name="item.name"
      no-caps
      class="q-pa-none row items-center justify-center"
      @click="router.push({ name: item.name })"
    >
      <q-card
        style="width: 82px; height: 60px"
        class="q-pa-sm"
        :class="tab === item.name ? 'border-color-primary' : ''"
      >
        <q-img
          :src="item.img"
          spinner-color="white"
          style="height: 100%; width: 100%"
          fit="contain"
        />
      </q-card>
      <div
        class="text-center text-weight-bold font-size-12 q-pt-xs"
        style="font-size: 10px"
      >
        {{ item.title }}
      </div>
    </q-tab>
  </q-tabs>
</template>

<script setup lang="ts">
import { useBase } from "@/composables/useBase";
import type { CardItem } from "@/types/common";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
const props = defineProps<{
  cardItems: CardItem[];
}>();

const tab = ref<string>(props.cardItems[0]?.name || "");
const route = useRoute();
const { router } = useBase();
onMounted(() => {
  tab.value = route.name as string;
});

watch(
  () => route.name,
  newRouteName => {
    tab.value = newRouteName as string;
  }
);
</script>

<style scoped></style>
